import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { ErrorMessage } from "@/Common/Api/Dto/ErrorMessage";
import { ErrorMessageComponent } from "@/Common/Components/Errors/ErrorMessageComponent";
import { InformationLoadingComponent } from "@/Common/Components/Loader/InformationLoadingComponent";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { PaymentGatewayTransactionDto, PaymentTransactionItemDto, SubscriptionGroupMyleDto, SubscriptionPaymentDto } from "@/Common/Models/Portal/MedfarPortal";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";

interface ISubscriptionTransactionDetailsProps {
    patientContactId: string;
    subscription: SubscriptionGroupMyleDto;
    payment: SubscriptionPaymentDto;
    onCloseCallBack: () => void;

}

class SubscriptionTransactionDetailsState {
    public isLoading = false;
    public errors: string[];
    public transactionDetails: PaymentGatewayTransactionDto;

    constructor(s: SubscriptionTransactionDetailsState = null) {
        if (s != null) {
            this.isLoading = s.isLoading;
            this.errors = s.errors;
        }
    }
}

class SubscriptionTransactionDetailsPopup extends React.Component<ISubscriptionTransactionDetailsProps, SubscriptionTransactionDetailsState> {
    private componentId = "TransactionDetails_Popup";

    constructor(props: ISubscriptionTransactionDetailsProps) {
        super(props);
        this.state = new SubscriptionTransactionDetailsState();
    }

    public componentDidMount(): void {
        overlayStore.showOverlay("SubscriptionTransactionDetailsPopup");
        this.loadTransactionDetails();

        const element = $(`#${this.componentId}`);

        const dragOptions = {
            containment: document.body,
            handle: ".dragHandle",
            stop() {
                element.draggable("destroy");
                element.css("height", "auto");
                window.setTimeout(() => {
                    element.draggable(dragOptions);
                }, 50);
            }
        };
        element.draggable(dragOptions);
        $(window).trigger("resize");
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay("SubscriptionTransactionDetailsPopup");
    }

    public render(): JSX.Element {
        let transactionDetails = this.state.transactionDetails;

        let paymentProfileRows: JSX.Element[] = [];
        if (transactionDetails && transactionDetails.PaymentProfile) {
            paymentProfileRows.push(
                <tr key="paymentProfileCardNumber">
                    <td className="c1-50p"><label className="form-label">{cacheStore.GetString("CardNumberLabel")}</label></td>
                    <td className="c2 left-align"><strong>{transactionDetails.PaymentProfile.DisplayName}</strong></td>
                </tr>
            );
            paymentProfileRows.push(
                <tr key="paymentProfileCardholderName">
                    <td className="c1-50p"><label className="form-label">{cacheStore.GetString("CardholderNameLabel")}</label></td>
                    <td className="c2 left-align"><strong>{transactionDetails.PaymentProfile.CardholderName}</strong></td>
                </tr>
            );
            paymentProfileRows.push(
                <tr key="paymentProfileBillingAddress">
                    <td className="c1-50p"><label className="form-label">{cacheStore.GetString("BillingAddressLabel")}</label></td>
                    <td className="c2 left-align">
                        <strong>
                            {transactionDetails.PaymentProfile.BillingAddress.Company}
                            {transactionDetails.PaymentProfile.BillingAddress.Company && <br />}
                            {transactionDetails.PaymentProfile.BillingAddress.StreetAddress}<br />
                            {transactionDetails.PaymentProfile.BillingAddress.City} {transactionDetails.PaymentProfile.BillingAddress.Province} {transactionDetails.PaymentProfile.BillingAddress.PostCode}
                        </strong>
                    </td>
                </tr>
            );
        }

        let transactionItems = transactionDetails && transactionDetails.Items
            ? transactionDetails.Items.map((i: PaymentTransactionItemDto, idx: number) => {
                const applicableTaxes = i.Taxable
                    ? (i.ApplicableTaxes && i.ApplicableTaxes.length ? i.ApplicableTaxes.map(p => p.TaxName).join(", ") : cacheStore.GetString("YesLabel"))
                    : "N/A";

                return (
                    <tr key={`itemdetail_${idx}`}>
                        <td>{i.Quantity}</td>
                        <td>{i.Description}</td>
                        <td>{i.UnitPrice.toFixed(2)}</td>
                        <td>{applicableTaxes}</td>
                        <th>{i.Price.toFixed(2)}</th>
                    </tr>
                );
            })
            : [];

        let isPaymentDoneInClinic = this.props.payment != null ? this.props.payment.PaymentGatewayName.toUpperCase() === "CLINIC" : false;
        return (
            <div className="popup portal-popup" id={this.componentId}>
                <div className="portal-messages-header">
                    <div className="itemGrow dragHandle">
                        <h3>{cacheStore.GetString("TransactionDetailsLabel")}</h3>
                    </div>
                    <div>
                        <a className="close" onClick={this.onCloseDialog.bind(this)} aria-label="Close" style={{ paddingTop: "10px" }}>×</a>
                    </div>
                    <h4 />
                </div>

                <div className="p-body myle-form portal-messages-body">

                    <ErrorMessageComponent errors={this.state.errors} />

                    {this.state.isLoading && (!this.state.errors || !this.state.errors.length) &&
                        <InformationLoadingComponent smallVersion={true} customMessage={cacheStore.GetString("WaitForPortalLabel")} />
                    }
                    <div className="flex-container">
                        {transactionDetails != null && (
                            <div className="trx-details">
                                <table>
                                    <tbody>
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("TransactionDateLabel")}</label></td>
                                            <td className="c2 left-align"><strong>{moment(transactionDetails.PaymentGatewayTransactionDate).format("YYYY-MM-DD HH:mm:SS")}</strong></td>
                                        </tr>
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("SubtotalLabel")}</label></td>
                                            <td className="c2 left-align"><strong>{transactionDetails.Subtotal.toFixed(2)}</strong></td>
                                        </tr>
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("TaxesLabel")}</label></td>
                                            <td className="c2 left-align"><strong>{transactionDetails.Tax.toFixed(2)}</strong></td>
                                        </tr>
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("TotalLabel")}</label></td>
                                            <td className="c2 left-align"><strong>{transactionDetails.Total.toFixed(2)}</strong></td>
                                        </tr>
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("TransactionIdLabel")}</label></td>
                                            <td className="c2 left-align"><strong>{transactionDetails.PaymentGatewayTransactionId}</strong></td>
                                        </tr>
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("TransactionStatusLabel")}</label></td>
                                            <td className="c2 left-align"><strong>{PortalHelper.getTransactionStatusDisplay(transactionDetails.Status)}</strong></td>
                                        </tr>
                                        {transactionDetails.PaymentGatewayCustomerId != null && (
                                            <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("CustomerIdLabel")}</label></td>
                                                <td className="c2 left-align"><strong>{transactionDetails.PaymentGatewayCustomerId}</strong></td>
                                            </tr>
                                        )}
                                        {transactionDetails.IsSettled != null && (
                                            <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("IsSettledLabel")}</label></td>
                                                <td className="c2 left-align"><strong>{transactionDetails.IsSettled.toString()}</strong></td>
                                            </tr>
                                        )}
                                        {paymentProfileRows}
                                        <tr><td className="c1-50p "><label className="form-label">{cacheStore.GetString("DetailsLabel")}</label></td>
                                            <td style={{ padding: "5px" }}>
                                                <table className="trx-item-details">
                                                    <thead>
                                                        <tr>
                                                            <td>{cacheStore.GetString("QuantityLabel")}</td>
                                                            <td>{cacheStore.GetString("DescriptionLabel")}</td>
                                                            <td>{cacheStore.GetString("UnitPriceLabel")}</td>
                                                            <td>{cacheStore.GetString("ApplicableTaxesLabel")}</td>
                                                            <td>{cacheStore.GetString("PriceLabel")}</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transactionItems}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}

                    </div>
                </div>
                <div className="p-footer">
                    <div className="col-lg-12 text-right">
                        <button onClick={this.onCloseDialog.bind(this)} className="btn btn-default push-right-5"><span>{cacheStore.GetString("CancelLabel")}</span></button>
                        <button onClick={this.onRefundClicked.bind(this)} disabled={this.state.isLoading} className="btn btn-warning push-right-5"><span>{isPaymentDoneInClinic ? cacheStore.GetString("VoidLabel") : cacheStore.GetString("RefundLabel")}</span></button>
                        <button onClick={this.onOkClicked.bind(this)} disabled={this.state.isLoading} className="btn btn-primary"><span>{cacheStore.GetString("OKLabel")}</span></button>
                    </div>
                </div>
            </div>
        );
    }

    private onCloseDialog(): void {
        if (this.props.onCloseCallBack != null)
            this.props.onCloseCallBack();
    }

    private onOkClicked(): void {
        if (this.props.onCloseCallBack != null)
            this.props.onCloseCallBack();
    }

    private onError(error: string): void {
        const s = new SubscriptionTransactionDetailsState(this.state);
        s.isLoading = false;
        s.errors = [error];
        this.setState(s);
    }

    private loadTransactionDetails(): void {
        if (this.props.payment != null) {
            const c = new Client();
            const payload = {
                TransactionId: this.props.payment.PaymentGatewayTransactionId,
                TransactionGateway: this.props.payment.PaymentGatewayName
            };

            c.Post(apiSettings.buildApiPath(), ServerOperations.Server.Portal_Proxy_GetTransactionDetails, payload, response => this.loadTransactionDetailsSuccess(response), error => this.onError(error));

            const s = new SubscriptionTransactionDetailsState();
            s.isLoading = true;
            s.transactionDetails = null;
            this.setState(s);
        }
    }

    private loadTransactionDetailsSuccess(response: any): void {
        const self = this;
        const errors = response.Errors as ErrorMessage[];

        const s = new SubscriptionTransactionDetailsState(self.state);

        if (errors && errors.length) {
            s.errors = errors.map((e: ErrorMessage) => e.Message);
        }
        else {
            s.transactionDetails = response.TransactionDetails;
        }

        s.isLoading = false;
        self.setState(s);
    }

    private onRefundClicked(): void {
        if (this.props.payment != null) {
            const c = new Client();
            const payload = {
                TransactionId: this.props.payment.PaymentGatewayTransactionId,
                TransactionGateway: this.props.payment.PaymentGatewayName
            };

            c.Post(apiSettings.buildApiPath(), ServerOperations.Server.Portal_Proxy_RefundTransaction, payload, response => this.onRefundSuccess(response), error => this.onError(error));

            const s = new SubscriptionTransactionDetailsState();
            s.isLoading = true;
            s.transactionDetails = null;
            this.setState(s);
        }
    }

    private onRefundSuccess(response: ServerEvent): void {
        const self = this;
        const errors = response.Errors as ErrorMessage[];

        const s = new SubscriptionTransactionDetailsState(self.state);
        if (errors && errors.length) {
            s.errors = errors.map((e: ErrorMessage) => e.Message);

            s.transactionDetails = null;
        }
        else {
            // todo reload transactions, send to serverdispatch handler so it reputs de transaction in the patientModel.PortalManagementOverview thing
            self.onCloseDialog();
        }

        s.isLoading = false;
        self.setState(s);
    }
}

export { SubscriptionTransactionDetailsPopup };
